<script setup>
    import __ from '@components/../mixins/locale'
    import axios from 'axios'
    import Comment from '@components/Comment.vue'
    import InputField from '@components/InputField.vue'
    import PhotoSwipe from 'photoswipe'
    import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
    import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue'

    const props = defineProps({
        items: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
            required: false
        },
        profile: {
            type: Object,
            required: false
        },
        userRoute: {
            type: String,
            required: false
        },
        previousPageUrl: {
            type: String,
            required: false
        },
        nextPageUrl: {
            type: String,
            required: false
        },
        perPage: {
            type: Number,
            required: false
        },
        uploader: {
            type: Boolean,
            required: false,
            default () {
                return false
            }
        },
        type: {
            type: Number,
            required: false
        },
        excludeFromGallery: {
            type: Boolean,
            required: false,
            default () {
                return false
            }
        },
        formErrors: {
            type: Object,
            required: false
        }
    });

    const emit = defineEmits(['uploaded']);

    const galleryItems = ref([]);
    
    const currentPhotoId = ref(null);
    
    const avatarPhotoId = ref(null);
    
    const form = ref({});
    
    const uploading = ref(false);
    
    const loading = ref(false);

    const errors = ref(null);

    

    const galleryOwner = computed(() => {
        if (props.profile && props.user) {
            if (props.profile.id === props.user.user_id) {
                return true;
            }
        } else if (props.uploader) {
            return true;
        }
        return false;
    });

    const uploadPhoto = () => {
        let formData = new FormData();
        let photos = form.value.photo;
        for (let photo of photos) {
            formData.append('photo[]', photo);
        }
        if (form.value.description) {
            formData.append('description', form.value.description);
        }
        if (props.excludeFromGallery) {
            formData.append('exclude_from_gallery', 1);
        }
        if (props.type) {
            formData.append('type', props.type);
        }
        formData.append('user_id', props.user.user_id);
        formData.append('api_token', props.user.api_token);
        axios.post(`/api/photo`, formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            uploading.value = true;
            response.data.forEach((photo) => {
                galleryItems.value.push(photo);
            });
            emit('uploaded', galleryItems.value);
            form.value = {};
        }).then(() => {
            uploading.value = false;
        }).catch(caughtErrors => {
            errors.value = caughtErrors.response.data.errors;
        });
    }

    const parseHash = () => {
        var hash = window.location.hash.substring(1),
        params = {};

        if(hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');  
            if(pair.length < 2) {
                continue;
            }           
            params[pair[0]] = pair[1];
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        return params;
    }

    const deletePhoto = () => {
        var galleryItemId = parseHash()['pid'] - 1;
        var photoId = galleryItems.value[galleryItemId].id;
        axios.delete('/api/photo/' + photoId + '?api_token=' + props.user.api_token)
            .then(response => {
                galleryItems.value.splice(galleryItemId, 1);
                window.gallery.close();
                loading.value = false;
            })
            .catch(caughtErrors => {
                errors.value = caughtErrors.response.data.errors;
            });
    }

    const useAsAvatar = () => {
        var galleryItemId = parseHash()['pid'] - 1;
        var photoId = galleryItems.value[galleryItemId].id;
        axios.patch('/api/photo/' + photoId + '?api_token=' + props.user.api_token, {
            type: 'avatar',
            user_id: galleryItems.value[galleryItemId].user_id
            })
            .then(response => {
                avatarPhotoId.value = photoId;
                loading.value = false;
            })
            .catch(caughtErrors => {
                errors.value = caughtErrors.response.data.errors;
            });
    }

    onMounted(() => {
        galleryItems.value = props.items;
        
        if (props.user && props.user.avatar_photo_id) {
            avatarPhotoId.value = props.user.avatar_photo_id;
        }

        var initPhotoSwipeFromDOM = function(gallerySelector) {

        // parse slide data (url, title, size ...) from DOM elements 
        // (children of gallerySelector)
        var parseThumbnailElements = function(el) {
            var thumbElements = el.childNodes,
                numNodes = thumbElements.length,
                items = [],
                figureEl,
                linkEl,
                size,
                item;

            for(var i = 0; i < numNodes; i++) {

                figureEl = thumbElements[i]; // <figure> element

                // include only element nodes 
                if(figureEl.nodeType !== 1) {
                    continue;
                }

                linkEl = figureEl.children[0]; // <a> element

                size = linkEl.getAttribute('data-size').split('x');

                // create slide object
                item = {
                    src: linkEl.getAttribute('href'),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10)
                };

                if(figureEl.children.length > 1) {
                    // <figcaption> content
                    item.title = figureEl.children[1].innerHTML; 
                }

                if(linkEl.children.length > 0) {
                    // <img> thumbnail element, retrieving thumbnail url
                    item.msrc = linkEl.children[0].getAttribute('src');
                } 

                item.el = figureEl; // save link to element for getThumbBoundsFn
                items.push(item);
            }

            return items;
        };

        // find nearest parent element
        var closest = function closest(el, fn) {
            return el && ( fn(el) ? el : closest(el.parentNode, fn) );
        };

        // triggers when user clicks on thumbnail
        var onThumbnailsClick = function(e) {
            e = e || window.event;
            e.preventDefault ? e.preventDefault() : e.returnValue = false;

            var eTarget = e.target || e.srcElement;

            // find root element of slide
            var clickedListItem = closest(eTarget, function(el) {
                return (el.tagName && el.tagName.toUpperCase() === 'DIV');
            });

            if(!clickedListItem) {
                return;
            }

            // find index of clicked item by looping through all child nodes
            // alternatively, you may define index via data- attribute
            var clickedGallery = clickedListItem.parentNode,
                childNodes = clickedListItem.parentNode.childNodes,
                numChildNodes = childNodes.length,
                nodeIndex = 0,
                index;

            for (var i = 0; i < numChildNodes; i++) {
                if(childNodes[i].nodeType !== 1) { 
                    continue; 
                }

                if(childNodes[i] === clickedListItem) {
                    index = nodeIndex;
                    break;
                }
                nodeIndex++;
            }



            if(index >= 0) {
                // open PhotoSwipe if valid index found
                openPhotoSwipe( index, clickedGallery );
            }
            return false;
        };

        // parse picture index and gallery index from URL (#&pid=1&gid=2)
        var photoswipeParseHash = function() {
            var hash = window.location.hash.substring(1),
            params = {};

            if(hash.length < 5) {
                return params;
            }

            var vars = hash.split('&');
            for (var i = 0; i < vars.length; i++) {
                if(!vars[i]) {
                    continue;
                }
                var pair = vars[i].split('=');  
                if(pair.length < 2) {
                    continue;
                }           
                params[pair[0]] = pair[1];
            }

            if(params.gid) {
                params.gid = parseInt(params.gid, 10);
            }

            return params;
        };

        var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
            var pswpElement = document.querySelectorAll('.pswp')[0],
                gallery,
                options,
                items;

            items = parseThumbnailElements(galleryElement);

            // define options (if needed)
            options = {

                // define gallery index (for URL)
                galleryUID: galleryElement.getAttribute('data-pswp-uid'),

                getThumbBoundsFn: function(index) {
                    // See Options -> getThumbBoundsFn section of documentation for more info
                    var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                        pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect(); 

                    return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
                }

            };

            // PhotoSwipe opened from URL
            if(fromURL) {
                if(options.galleryPIDs) {
                    // parse real index when custom PIDs are used 
                    // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                    for(var j = 0; j < items.length; j++) {
                        if(items[j].pid == index) {
                            options.index = j;
                            break;
                        }
                    }
                } else {
                    // in URL indexes start from 1
                    options.index = parseInt(index, 10) - 1;
                }
            } else {
                options.index = parseInt(index, 10);
            }

            // exit if index not found
            if( isNaN(options.index) ) {
                return;
            }

            if(disableAnimation) {
                options.showAnimationDuration = 0;
            }

            // Pass data to PhotoSwipe and initialize it
            window.gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
            window.gallery.init();
            
            window.gallery.listen('imageLoadComplete', () => {
                currentPhotoId.value = galleryItems.value[window.gallery.getCurrentIndex()].id;
            });

            /*
            MOBILE
            last image, swipe next page - 
                indexDiff: 1
                window.gallery.getCurrentIndex(): 0
            
            first image, swipe previous page - 
                indexDiff: -1
                window.gallery.getCurrentIndex(): 19

            DESKTOP
            last image, swipe next page
                indexDiff: -19
                window.gallery.getCurrentIndex(): 0

            first image, swipe previous page
                indexDiff: 19
                window.gallery.getCurrentIndex(): 19
            */
            window.gallery.listen('beforeChange', (indexDiff) => {
                if (
                    (props.previousPageUrl && indexDiff > 1) // DESKTOP CLICK
                    ||
                    (props.previousPageUrl && indexDiff == -1 && window.gallery.getCurrentIndex() == (props.perPage - 1)) // MOBILE SWIPE
                    ) { // PREVIOUS PAGE
                    window.gallery.destroy();
                    window.location.href = props.previousPageUrl;
                } else if (
                    (props.nextPageUrl && indexDiff < -1) // DESKTOP CLICK
                    ||
                    (props.nextPageUrl && indexDiff == 1 && window.gallery.getCurrentIndex() == 0) // MOBILE SWIPE
                    ) { // NEXT PAGE
                    window.gallery.destroy();
                    window.location.href = props.nextPageUrl;
                }
            });
            
            window.gallery.listen('afterChange', () => {
                currentPhotoId.value = galleryItems.value[window.gallery.getCurrentIndex()].id;
            });
        };

        // loop through all gallery elements and bind events
        var galleryElements = document.querySelectorAll( gallerySelector );

            for(var i = 0, l = galleryElements.length; i < l; i++) {
                galleryElements[i].setAttribute('data-pswp-uid', i+1);
                galleryElements[i].onclick = onThumbnailsClick;
            }

            // Parse URL and open gallery if it contains #&pid=3&gid=1
            var hashData = photoswipeParseHash();
            if(hashData.pid && hashData.gid) {
                setTimeout(() => {
                    openPhotoSwipe( hashData.pid,  galleryElements[ hashData.gid - 1 ], true, true );
                }, 5000);
            }
        };

        // execute above function
        initPhotoSwipeFromDOM('.my-gallery');
    });

    watch(() => props.formErrors, (val) => {
        errors.value = val;
    });

    watch(() => props.items, (val) => {
        galleryItems.value = val;
    },
  { deep: true });
</script>

<template>
    <div>
        <div v-if="galleryOwner && !uploading" style="margin-bottom: 20px">
            <label>{{ __('Upload photos') }}</label>
            <div class="row">
                <InputField input-type="file" name="photo" :label="__('Photo')" :errors="errors" placeholder="" @update:field="form.photo = $event" :data="form.photo" />
                <InputField v-if="form.photo && form.photo.length == 1" input-type="text" name="description" :label="__('Description')" :disable-label="true" :errors="errors" :placeholder="__('Description')" @update:field="form.description = $event" :data="form.description" />
            </div>
            <div class="row" v-if="form.photo">
                <div class="col">
                    <button type="button" class="btn btn-primary btn-md" @click="uploadPhoto">{{ __('Upload') }}</button>
                </div>
            </div>
        </div>
        
        <div class="my-gallery card-columns" itemscope itemtype="http://schema.org/ImageGallery">
            <div v-for="galleryItem in galleryItems" class="card contrast-block story-block card-body">
                <a :href="'/storage' + (user ? galleryItem.original.src : galleryItem.thumbnail.src)" itemprop="contentUrl" :data-size="(user ? galleryItem.original.width : galleryItem.thumbnail.width) + 'x' + (user ? galleryItem.original.height : galleryItem.thumbnail.height)">
                    <span v-if="galleryItem.comments_count > 0" style="position: absolute; right: 5px;" class="badge badge-primary" :title="__('Comments')">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="comments" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="width: .7rem"><path fill="currentColor" d="M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"></path></svg>
                        <span>{{ galleryItem.comments_count }}</span>
                    </span>
                    <img :src="'/storage' + (galleryItem.thumbnail.src)" itemprop="thumbnail" alt="Image description" />
                </a>
                <div itemprop="caption description">
                    <a v-if="galleryItem.user && galleryItem.user.username && userRoute" :href="'/' + userRoute + '/' + galleryItem.user.username">{{ galleryItem.user.username }}</a><template v-if="galleryItem.user && galleryItem.user.username && userRoute && galleryItem.description > ''"> - </template>{{ galleryItem.description }}
                </div>                
            </div>
        </div>

        <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
            <Comment class="photo-comments" v-if="currentPhotoId" ref="comment_on_photo" :is-photo-comment="true" :contextual-id="currentPhotoId" :type="3" :user-id="user ? user.user_id : null"></Comment>
            <div class="pswp__bg"></div>
            <div class="pswp__scroll-wrap">
                <div class="pswp__container">
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                    <div class="pswp__item"></div>
                </div>
                <div class="pswp__ui pswp__ui--hidden">
                    <div v-if="!user" class="jumbotron register-block">
                        <div class="text-center" style="padding-top: 10px;">
                            <p>{{ __('Log in or register to view large photos') }}...</p>
                            <a href="/register" class="btn btn-info btn-sm" role="button">{{ __('Register') }}</a> / <a href="/login" class="btn btn-secondary btn-sm" role="button">{{ __('Login') }}</a>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <div class="pswp__top-bar">
                        <div class="pswp__counter"></div>
                        <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                        <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                        <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                        <div class="pswp__preloader">
                            <div class="pswp__preloader__icn">
                                <div class="pswp__preloader__cut">
                                    <div class="pswp__preloader__donut"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                        <div class="pswp__share-tooltip"></div> 
                    </div>
                    <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
                    <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
                    <div class="pswp__caption">
                        <div class="pswp__caption__center"></div>
                        <div class="float-right">
                            <button type="button" class="btn btn-secondary mr-4 mb-4" v-if="(galleryOwner || (user && user.user_id == 80 && user.username == 'admin')) && currentPhotoId != avatarPhotoId" @click="useAsAvatar">
                                {{ __('UseasAvatar') }}
                            </button>
                            <button type="button" class="btn btn-danger mr-4 mb-4" v-if="galleryOwner || (user && user.user_id == 80 && user.username == 'admin')" @click="deletePhoto">
                                <svg style="width: 25px; height: 25px;" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z" class=""></path></svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import '../../../node_modules/photoswipe/dist/photoswipe.css';
@import '../../../node_modules/photoswipe/dist/default-skin/default-skin.css';
.pswp {
    overflow: visible;
}
.photo-comments {
    position: absolute;
    z-index: 9999;
    overflow-y: auto;
}
.my-gallery img {
  width: 100%;
}
.my-gallery div > div {
  display: none;
}
.my-gallery.card-columns {
    column-count: 6;
    .card-body {
        padding: 0;
        border: none;
    }
}
@media (min-width: 576px) and (max-width: 767px) {
    .my-gallery.card-columns {
        column-count: 5;
    }
}
@media (max-width: 575px) {
    .my-gallery.card-columns {
        column-count: 3;
    }
}
@media (max-width: 999px) {
    .pswp {
        height: 69%;
    }
    .photo-comments {
        bottom: -45%;
        width: 100%;
        height: 47%;
    }
}
@media (min-width: 1000px) {
    .pswp {
        width: 69%;
    }
    .photo-comments {
        right: -45%;
        width: 45%;
        height: 100%;
    }
}
</style>